import { useTranslation } from 'react-i18next';

import { Icons } from '~/components/Icon/constants';
import OptionsMenuItem from '~/components/OptionsMenu/components/OptionsMenuItem';

interface IUnfollowMenuItemProps {
  isFollowing?: boolean;
  parentEntityLabel?: string;
  onClickCallback?: () => void;
  toggleFollow?: () => void;
}

const UnfollowMenuItem = ({
  isFollowing,
  onClickCallback,
  toggleFollow,
  parentEntityLabel,
}: IUnfollowMenuItemProps): JSX.Element | null => {
  const { t } = useTranslation();

  const labelText = parentEntityLabel
    ? t(isFollowing ? 'optionsMenu.unfollow' : 'optionsMenu.follow', { parentEntityLabel })
    : t(isFollowing ? 'optionsMenu.unfollowLabel' : 'optionsMenu.followLabel');

  return (
    <OptionsMenuItem
      icon={isFollowing ? Icons.MinusCircle : Icons.PlusCircle}
      onClick={() => {
        toggleFollow?.();
        onClickCallback?.();
      }}
      text={labelText}
    />
  );
};

export default UnfollowMenuItem;
